import { Amplify } from 'aws-amplify'
import { env } from '@/config/env'

/**
 * Configure aws-amplify v6 for Cognito User Pool + Identity Pool + AppSync GraphQL.
 *
 * Mirror del setup mobile (vedi enermed-app/aws-utils/aws-exports.js):
 *   - Auth → Cognito User Pool (con eventuale Identity Pool)
 *   - API.GraphQL → AppSync endpoint, authMode `userPool` (Cognito ID token nel header)
 *
 * Call once at app bootstrap (see main.tsx).
 */
export function configureAmplify() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: env.cognito.userPoolId,
        userPoolClientId: env.cognito.userPoolClientId,
        identityPoolId: env.cognito.identityPoolId || undefined,
        loginWith: {
          username: true,
          email: false,
          phone: false,
        },
      },
    },
    API: {
      GraphQL: {
        endpoint: env.api.baseUrl,
        region: env.cognito.region,
        defaultAuthMode: 'userPool',
      },
    },
  })
}
